<script lang="ts">
    import clsx from 'clsx';
    import { afterUpdate } from 'svelte';

    // Types
    import type { ComponentType } from 'svelte';

    export let open = false;
    export let title = '';
    export let style = '';
    export let contentStyle = '';
    export let handleClose: (event: MouseEvent | TouchEvent) => any;
    export let actionButtonsComponent: ComponentType | undefined = undefined;
    export let actionButtonsProps = {};

    let contentClasses: string;
    let wrapperClasses: string;

    afterUpdate(() => {
        document.body.style.overflow = open ? 'hidden' : 'auto';
    });

    $: wrapperClasses = clsx(
        'h-screen w-screen fixed inset-0 z-[1000] transition-colors duration-300 touch-none',
        {
            'pointer-events-none max-h-0 bg-transparent': !open,
            'max-h-screen bg-black/50': open,
        },
    );
    $: contentClasses = clsx(
        contentStyle,
        'fixed max-h-[95%] flex flex-col overflow-hidden bottom-0 right-0 left-0 z-[1000] duration-[500ms] ease-[cubic-bezier(.59,.76,.18,.97)] w-full origin-bottom transform transition-all rounded-t-3xl bg-white',
        {
            'pointer-events-none opacity-0 scale-y-0': !open,
            'opacity-100 scale-y-1': open,
        },
    );
</script>

<div class={`${wrapperClasses} ${style}`} on:click|stopPropagation={handleClose}>
    <div class={contentClasses} on:click|stopPropagation>
        <div
            class="sticky top-0 z-[1000] flex w-full items-center justify-between border-b bg-white p-6 pb-4 font-ui text-lg font-semibold"
        >
            {title}
            <div class="fill-gray-500" on:click={handleClose}>
                <svg
                    xmlns="http://www.w3.org/2000/svg"
                    viewBox="0 0 24 24"
                    width="24px"
                    height="24px"
                    ><path d="M0 0h24v24H0z" fill="none" />
                    <path
                        d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
                    />
                </svg>
            </div>
        </div>
        <slot />
        {#if !!actionButtonsComponent}
            <div class="bottom-0 left-0 right-0 z-20 w-full border-t border-gray-200 bg-white pt-4">
                <svelte:component this={actionButtonsComponent} {...actionButtonsProps} />
            </div>
        {/if}
    </div>
</div>
